import { createStates } from '@/constants/lifecycle';

export const datasetNotification = () => ({
  code: '',
  open: false,
  datasetName: '',
  update: {
    description: '',
    name: '',
  },
  ...createStates,
});

const initialState = {
  datasetNotification: datasetNotification(),
};

export default initialState;
